export const GET_EXTRA_CONTENT = 'GET_EXTRA_CONTENT';
export const GET_EXTRA_CONTENT_SUCCESS = 'GET_EXTRA_CONTENT_SUCCESS';
export const CLEAR_EXTRA_CONTENT = 'CLEAR_EXTRA_CONTENT';